var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video-player',{style:(_vm.getStyle()),attrs:{"options":_vm.videoOptions}})}
var staticRenderFns = []

export { render, staticRenderFns }